/**
 * Five quick taps on the sidebar brand bar trigger confetti once.
 * For Media Devoted | Created By Ciro Autiero
 */

import { useCallback, useRef, type PointerEvent } from 'react';

import { playSidebarConfetti } from './playSidebarConfetti';

const CLICKS_REQUIRED = 5;
const RESET_MS = 2800;

export function useSidebarLogoEasterEgg() {
  const countRef = useRef(0);
  const resetRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const clearResetTimer = useCallback(() => {
    if (resetRef.current !== null) {
      clearTimeout(resetRef.current);
      resetRef.current = null;
    }
  }, []);

  const onBrandBarPointerDown = useCallback(
    (event: PointerEvent<HTMLDivElement>) => {
      if (event.button !== 0) return;
      clearResetTimer();
      countRef.current += 1;
      if (countRef.current < CLICKS_REQUIRED) {
        resetRef.current = setTimeout(() => {
          countRef.current = 0;
          resetRef.current = null;
        }, RESET_MS);
        return;
      }
      countRef.current = 0;
      playSidebarConfetti();
    },
    [clearResetTimer],
  );

  return { onBrandBarPointerDown };
}
